import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types";

import { StyledBox } from "./style";

function createSvgImage(path, displayName, propsStd = {}) {
  const Component = (props, ref) => {
    const propsNew = { ...propsStd, ...props };

    return (
      <SvgImage data-test={`${displayName}Icon`} ref={ref} {...propsNew}>
        {path instanceof Function ? path(propsNew) : path}
      </SvgImage>
    );
  };

  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `${displayName}Image`;
  }

  return memo(forwardRef(Component));
}

const SvgImage = forwardRef(function SvgImage(props, ref) {
  const { children, htmlColor, titleAccess, ...other } = props;

  return (
    <StyledBox focusable="false" color={htmlColor} ref={ref} {...other}>
      {children}
      {titleAccess ? <title>{titleAccess}</title> : null}
    </StyledBox>
  );
});

SvgImage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
  htmlColor: PropTypes.string,
  shapeRendering: PropTypes.string,
  titleAccess: PropTypes.string,
  viewBox: PropTypes.string,
};

SvgImage.createSvgImage = createSvgImage;

export default SvgImage;
